import pluralize from "pluralize";
import type { UiLabels } from "./UiLabels.types";

export const defaultUiLabels: UiLabels = {
  banner: { dismiss: "Dismiss banner" },
  bulkActions: { selected: (count) => `${count} selected`, actions: "Actions", submenu: "Submenu" },
  citations: { sources: "Citation sources" },
  emailInput: {
    label: "Emails",
    placeholder: "Add emails here, separated by commas or spaces",
    suggestions: "Member suggestions",
    loading: "Loading…",
    invalid: "One or more emails not valid.",
  },
  moveDestination: {
    title: (count) => `Move ${pluralize("item", count, true)}`,
    search: "Search...",
    newProject: "New project",
    newFolder: "New folder",
    cancel: "Cancel",
    move: "Move",
    moveHere: (count) => `Move ${pluralize("item", count, true)} here.`,
    noProjects: "No projects found.",
  },
  multiSelect: { showOptions: "Show options", hideOptions: "Hide options", loading: "Loading…" },
  scopeNavigation: {
    root: "ALL",
    current: "CURRENT",
    noItems: "No items found",
    navigateTo: (name) => `Navigate to ${name}`,
    select: (name) => `Select ${name}`,
    selected: (name) => `${name} selected`,
  },
  scopeSelector: {
    title: "Select Items",
    search: "Search...",
    selected: "SELECTED",
    showMore: "Show more",
    showLess: "Show less",
    clearSelection: "Clear selection",
    cancel: "Cancel",
    apply: "Apply",
    noProjects: "No projects found.",
    noFilesOrFolders: "No files or folders found.",
  },
  search: { tooltip: "Search", open: "Open search" },
  sidePanelPagination: {
    pageWithNumber: (page) => `Page ${page}`,
    previous: "Previous",
    previousPage: "Previous page",
    next: "Next",
    nextPage: "Next page",
  },
  table: { loading: "Loading..." },
  valueFilter: { min: "Min value", max: "Max value" },
};
